import React from "react";
import { Field, reduxForm } from "redux-form";
import { Redirect } from "react-router-dom";
import FormElement from "../../forms/form_element";
import { seedcastForm } from "../../../lib/forms";
import LoadingButton from "../../forms/loading_button/loading_button";

let SignInForm = props => {
  if (typeof props.user !== "undefined" && props.user !== null) {
    return <Redirect to="/" />;
  }
  return (
    <form onSubmit={props.handleSubmit}>
      {props.hasError && (
        <div className="alert alert-danger" role="alert">
          {props.errorMessage}
        </div>
      )}
      <div>
        <Field component={FormElement} name="email" label="Email" type="email" />
      </div>
      <div>
        <Field
          component={FormElement}
          label="Password"
          name="password"
          type="password"
          style={{ fontSize: "28px" }}
        />
      </div>
      <hr className="redcircle-divider" />
      <LoadingButton
        disabled={!props.submitEnabled}
        type="submit"
        className="btn btn-primary btn-block sign-in-form__submit-button"
        isLoading={props.isLoading}
        Button={"button"}>
        Sign In
      </LoadingButton>
    </form>
  );
};

SignInForm = reduxForm({
  form: "sign-in",
})(SignInForm);
SignInForm = seedcastForm(SignInForm);

export default SignInForm;
